import { render } from "./DashboardLayout.vue?vue&type=template&id=0a6f81eb&scoped=true"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"

import "./DashboardLayout.vue?vue&type=style&index=0&id=0a6f81eb&scoped=true&lang=css"
import "./DashboardLayout.vue?vue&type=style&index=1&id=0a6f81eb&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6f81eb"]])

export default __exports__